import btnClose from "../../../img/icon/btn_close.svg";
import styles from "./ButtonClose.module.css";

interface ButtonProps {
    onClick: (args: any) => any;
}

const ButtonClose = (props: ButtonProps) => {
    return (
        <div className={styles.header}>
            <button className={styles.button} onClick={props.onClick}>
                <img src={btnClose} />
            </button>
        </div>
    );
};

export default ButtonClose;
